import { initialState } from "./state"

export default {
  setAdditives: (state, payload) => (state.additives = payload),
  setAccession: (state, payload) => {
    state.accession = payload
  },
  updateAdditives: (state, { payload, index }) => {
    state.additives[index] = payload
  },
  updateDiscount: (state, payload) => (state.discount = payload),
  updateContractType: (state, payload) => (state.contract_type = payload),
  updateShipping: (state, payload) => (state.shipping = payload),
  updateShippingName: (state, payload) => (state.shippingName = payload),
  updateDueDate: (state, payload) => (state.dueDate = payload),
  updatePayment: (state, payload) => (state.payment = payload),
  updateUUID: (state, payload) => (state.uuid = payload),
  updateContractAddress: (state, payload) => state.contractAddress = payload,
  updateContractExternalId: (state, payload) => state.contractExternalId = payload,
  updateContractPersonExternalId: (state, payload) => state.personExternalId = payload,
  resetContract: state => {
    const init_state = initialState()
    const keysToKeep = ['shippingMethodsOptions', 'paymentTypesOptions', 'dueDaysOptions']
    Object.keys(state).forEach(key => {
      if (!keysToKeep.includes(key)) {
        state[key] = init_state[key]
      }
    })
  },
  setPaymentTypesOptions(state, payload) {
    state.paymentTypesOptions = payload
  },
  setShippingMethodsOptions(state, payload) {
    state.shippingMethodsOptions = payload
  },
  setDueDaysOptions(state, payload) {
    state.dueDaysOptions = [
      state.dueDaysOptions[0],
      ...payload
    ]
  },
  resetContractOptions(state) {
    state.paymentTypesOptions = []
    state.shippingMethodsOptions = []
    state.dueDaysOptions = [state.dueDaysOptions[0]]
  },
  updateServiceOrigin(state, payload) {
    state.serviceOrigin = payload
  }
}
